export enum CustomerProblem {
  AlmostExceededStorageLimit = 'AlmostExceededStorageLimit',
  ExceededStorageLimit = 'ExceededStorageLimit',
  InvoiceProblem = 'InvoiceProblem',
  LicenseProblem = 'LicenseProblem',
  MailboxPermissionsMissing = 'MailboxPermissionsMissing',
  NoProblem = 'NoProblem',
  RestoreAbilityExpired = 'RestoreAbilityExpired',
  PlanExpired = 'PlanExpired',
  PlanWillExpired = 'PlanWillExpired',
  StorageNotSet = 'StorageNotSet',
  StorageImmutabilityActive = 'StorageImmutabilityActive',
  StorageImmutabilityWithoutPolicyActive = 'StorageImmutabilityWithoutPolicyActive',
  TrialRestriction = 'TrialRestriction',
  TrialWillExpired = 'TrialWillExpired'
}
